(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InvoiceEnvironmentalSearch', InvoiceEnvironmentalSearch);

    InvoiceEnvironmentalSearch.$inject = ['$resource'];

    function InvoiceEnvironmentalSearch($resource) {
        var resourceUrl =  'api/_search/invoice-environmentals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
